export const GridConfig = {
  container: {
    xs: 'full',
    sm: 'full',
    md: 'full',
    lg: 70,
    xl: 70,
  },
};
